<app-confirmacao-painel-manutencoes [confirmacaoPainelManutencoes]="alertConfirmacao" (confirmacaoPainelManutencoesFechou)="fecharAlertConfirmacao($event)"></app-confirmacao-painel-manutencoes>
<app-loading-generico [loadingGenerico]="loadingDelete"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)"></app-success-generico>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

<app-manutencao-toolbar
  [(campoInput)]="campoInput"
  [buscaFiltrada]="buscaFiltrada"
  placeholder="Buscar por código ou descrição arquivo"
  [tagBuscar]="addTagManagerInteraction('box:search:click', 'buscar-por-codigo-ou-descricao-arquivo')"
  [tagLimpar]="addTagManagerInteraction('box:button:click', 'limpar-filtro')"
  (buscar)="buscaFiltradaPorInput()"
  (limpar)="limparFiltro()">
</app-manutencao-toolbar>

@if (produtos) {
  <table class="table table-hover border-bottom">
    <caption>Tabela com a listagem de produtos</caption>
    <thead>
      <tr>
        <th scope="col" class="border-top-0">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="selecionaTodosPedidos" (change)="selecionaTodos($event.target)">
            <label class="form-check-label" for="selecionaTodosPedidos"> </label>
          </div>
        </th>
        <th scope="col" class="border-top-0"><span class="text-nowrap">COD. PROD</span><br><span class="text-nowrap">NO ARQUIVO</span></th>
        <th scope="col" class="border-top-0">DESCRIÇÃO<br>DO ARQUIVO</th>
        <th scope="col" class="border-top-0">COD. PROD<br>CORRESPONDENTE</th>
        <th scope="col" class="border-top-0">DESCRIÇÃO</th>
        <th scope="col" class="border-top-0">TARIFA</th>
        <th scope="col" class="border-top-0">OPERADORA</th>
        <th scope="col" class="border-top-0">SUB-ITEM</th>
        <th scope="col" class="border-top-0"></th>
      </tr>
    </thead>
    <tbody>
      @for (produto of produtos.data; track produto) {
        <tr>
          <td class="pt-2">
            <div class="form-check">
              <input type="checkbox" class="form-check-input"
                id="{{produto.codigoBeneficioArquivo}}"
                name="inputsProdutos"
                [attr.aria-label]="produto.codigoBeneficioArquivo + ':' + produto.produto.codigoVenda"
                [tag]="addTagManagerInteraction('select:checkbox:click', produto.codigoBeneficioArquivo+':'+produto.produto.codigoVenda)">
              <label class="form-check-label" for="{{produto.codigoBeneficioArquivo}}"></label>
            </div>
          </td>
          <td class="coluna-destaque">{{produto.codigoBeneficioArquivo}}</td>
          <td class="coluna-destaque">{{produto.descricaoBeneficioArquivo}}</td>
          <td>{{produto.produto.codigoVenda}}</td>
          <td>{{produto.produto.descricaoProduto}}</td>
          <td>{{produto.produto.valor}}</td>
          <td>{{produto.produto.fabricante}}</td>
          <td>{{produto.produto.regiao}}</td>
          <td>
            <button
              (click)="showAlertConfirmacao('excluirUnico', produto.codigoBeneficioArquivo)"
              (keydown.enter)="showAlertConfirmacao('excluirUnico', produto.codigoBeneficioArquivo)"
              [tag]="addTagManagerInteraction('select:icon:click', produto.codigoBeneficioArquivo+':'+produto.produto.codigoVenda+'-excluir')"
              class="btn-icon">
              <i class="fa fa-trash c-primary" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (produtos) {
  <div class="w-100 text-center">
    <button class="botaoLongo mt-4" (click)="showAlertConfirmacao('excluirSelecionados', '')">EXCLUIR SELECIONADOS</button>
  </div>
}

<app-manutencao-footer
  [dados]="produtos"
  [tamanho]="tamanho"
  [pagina]="pagina"
  [itensPaginacao]="itensPaginacao"
  [tagDropdown]="addTagManagerInteraction('select:dropdown:click', 'exibir-por-pagina')"
  [tagPagina]="addTagManagerInteraction('select:number:click', 'escolher-proxima-pagina')"
  (tamanhoChange)="tamanho = $event"
  (alterarTamanho)="alteraQuantidadePorPagina()"
  (alterarPagina)="alteraPagina($event)">
</app-manutencao-footer>

<app-lista-estado
  [dados]="produtos"
  mensagemCarregando="Consultando produtos ..."
  mensagemErro="Ocorreu um erro na consulta de produtos."
  mensagemVazio="Não existem produtos para essa consulta.">
</app-lista-estado>
